import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import StatsBar from "@/pages/home/components/StatsBar";
import QuickEntry from "@/pages/home/components/QuickEntry";
import TopicWall from "@/pages/home/components/TopicWall";
import CommentPreview from "@/pages/home/components/CommentPreview";
import FollowFlow from "@/pages/home/components/FollowFlow";
import DownloadCta from "@/pages/home/components/DownloadCta";
import CommunityRules from "@/pages/home/components/CommunityRules";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div id="top" className="w-full min-h-screen bg-background-50 text-foreground-950">
      <SiteHeader />
      <main className="w-full">
        <HeroSection />
        <StatsBar />
        <QuickEntry />
        <TopicWall />
        <CommentPreview />
        <FollowFlow />
        <DownloadCta />
        <CommunityRules />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}